import Api from "./Api";

export default {
  AddSeatTypes(payload) {
    return Api().post(`/api/admin/seattype`, payload);
  },
  GetSeatTypes(payload) {
    return Api().get(
      `/api/admin/seattype?limit=${payload.limit}&currentPage=${payload.currentPage}&columnName=${payload.columnName}&orderBy=${payload.orderBy}&cinema_id=${payload.cinema_id}&isExcel=${payload.isExcel}&cinema_name=${payload.cinema_name}&cinema_address=${payload.cinema_address}`
    );
  },
  GetSeatTypesById(payload) {
    return Api().get(`/api/admin/seattype/${payload.sst_id}`);
  },
  UpdateSeatTypes(payload) {
    return Api().put(`/api/admin/seattype/${payload.sst_id}`, payload);
  }
};



// WEBPACK FOOTER //
// ./src/services/SeatService.js